import { LoadableAfterPaint } from '@confluence/loadable';
import React from 'react';

export const OnboardingNudge = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-OnboardingNudgeTooltip" */ '../src/OnboardingNudgeTooltip'
			)
		).OnboardingNudge,
	loading: ({ children, renderChildrenWhileLoading }) =>
		renderChildrenWhileLoading ? <>{children}</> : null,
});
